/* eslint-disable */
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
// material
import {
    Container, Card
} from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, InputAdornment, Button, Box } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Divider from '@material-ui/core/Divider';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import EditIcon from '@material-ui/icons/Edit';
import { AESEncryptionParam } from '../../../../helpers/AesEncrypt';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import SearchNotFound from '../../../SearchNotFound';
import userServices from '../../../../commonServices/UserServices';
import services from '../Services';
import Chip from '@material-ui/core/Chip';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import { RotateLeft } from '@material-ui/icons';
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes, { func } from 'prop-types'
import { useTheme } from '@mui/material/styles'

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
        
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
        
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

export default function OperationEntityListing(props) {
    const screenCode = 'OPERATIONENTITY';
    let encrypted = "";
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        groupID: "0",
        operationEntityTypeID: 0

    });
    const [groupList, setGroupList] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false
    });
    const OperationEntitiySearchSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please select a Group').required('Group Required')
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityTypeID: formData.operationEntityTypeID
        },
        validationSchema: OperationEntitiySearchSchema,
        onSubmit: (values) => {
            values.operationEntityTypeID !== 0 ?
                trackPromise(GetOperationEntities(values.groupID, values.operationEntityTypeID))
                : trackPromise(GetAllOperationEntities(values.groupID));
        },
    });

    async function GetOperationEntities(groupID, operationEntityTypeID) {
        var res = await services.GetAllFactoriesByFactoryType(groupID, operationEntityTypeID);
        if (res != null) {
            setTableData(res);
        }

    }

    async function GetAllOperationEntities(groupID) {
        var res = await services.GetAllFactoriesByGroupID(groupID);
        if (res != null) {
            let final = res.filter((x) => (x.factoryType != 3))
            setTableData(final);
        }

    }

    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tableData.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    useEffect(() => {
        const storedFormData =JSON.parse(sessionStorage.getItem('operationEntityFormData'));
        const storedPage = JSON.parse(sessionStorage.getItem('operationEntityPage')); 
        getPermissions(storedFormData, storedPage);
        sessionStorage.removeItem('operationEntityFormData');
        sessionStorage.removeItem('operationEntityPage');

    }, []);

    useEffect(() => {
        setTableData([]);
      }, [formik.values.operationEntityTypeID]);
    
    async function getPermissions(storedFormData,storedPage) {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWOPERATIONENTITY');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
        });
        const isInitialLoading = storedFormData === null
        if (isInitialLoading) {
            setValues({
                ...values,
                groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            })
        } else {
            setValues({
                ...values,
                groupID: parseInt(storedFormData.groupID),
                operationEntityTypeID: parseInt(storedFormData.operationEntityTypeID)
            })
            if (storedFormData.operationEntityTypeID !== 0) {
                trackPromise(GetOperationEntities(storedFormData.groupID, storedFormData.operationEntityTypeID));
            } else {
                trackPromise(GetAllOperationEntities(storedFormData.groupID));
            }
            if (storedPage !== null) {
                setPage(storedPage);
            }
        }
        trackPromise(GetAllGroups());
    }

    async function GetAllGroups() {
        var res = await services.GetAllGroupsForDropDown();
        if (res != null) {
            setGroupList(res);
        }
    }

    async function clearAll() {
        setPage(0);
        setTableData([]);
        sessionStorage.removeItem('operationEntityFormData'); 
        sessionStorage.removeItem('operationEntityPage'); 
        setValues({...values,operationEntityTypeID: 0}); 
    }


    function handleClick(datas) {
        setPage(0);
        sessionStorage.setItem('operationEntityFormData', JSON.stringify(values));
        sessionStorage.setItem('operationEntityPage', JSON.stringify(page));
        encrypted = AESEncryptionParam(datas.factoryID.toString());
        navigate('/dashboard/operationEntity/AddEdit/' + encrypted);
    }



    return (
        <>
            <LoadingComponent />
            <Page title="Operation Entity |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/dashboard/operationEntity/AddEdit/" + AESEncryptionParam("0")}
                        btname="Add"
                        pageName="Operation Entity"
                    />
                    <FormikProvider value={formik}>

                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form enableReinitialize autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Stack spacing={4}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>

                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        id="groupID"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group</MenuItem>
                                        {groupList.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        id="operationEntityTypeID"
                                        size="small"
                                        label="Operation Entity Type "
                                        value={formik.values.operationEntityTypeID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('operationEntityTypeID')}
                                        helperText={touched.operationEntityTypeID && errors.operationEntityTypeID}
                                    >
                                        <MenuItem key={0} value={0}>Select Operation Entity Type</MenuItem>
                                        <MenuItem value={1}>FDC</MenuItem>
                                        <MenuItem value={2}>FCC</MenuItem>
                                        <MenuItem value={4}>Head Office</MenuItem>
                                        <MenuItem value={5}>Finance</MenuItem>

                                    </TextField>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                        <Button
                                            type="button"
                                            color='error'
                                            variant="outlined"
                                            onClick={() => clearAll()}
                                        > Clear</Button>
                                        <Button
                                            type="submit"
                                            color='secondary'
                                            variant="outlined"
                                        >Search</Button>
                                    </Stack>
                                </Stack>
                            </Stack>
                        </Form>
                    </FormikProvider>
                    <br />
                    {tableData.length == 0 ?
                        <SearchNotFound searchQuery="Operation Entities" />
                        :
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                            <Card style={{ justifycontent: 'center', width: '85rem' }} >
                                <TableContainer component={Paper} >
                                    <Table size='small' aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="center">Operation Entity Code</TableCell>
                                                <TableCell align="center">Operation Entity Name</TableCell>
                                                <TableCell align="center">Status</TableCell>
                                                <TableCell align="center">Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {(rowsPerPage > 0
                                                ? tableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                : tableData
                                            ).map((row) => (
                                                <TableRow key={row.factoryID}>
                                                    <TableCell align="center" component="th" scope="row">
                                                        {row.factoryCode}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {row.factoryName}
                                                    </TableCell>
                                                    <TableCell align="center">{row.isActive ? <Chip size="small" label="Active" style={{ color: 'green' }} /> : <Chip size="small" label="Inactive" style={{ color: 'red' }} />}</TableCell>
                                                    <TableCell align="center">{<IconButton aria-label="delete" onClick={() => handleClick(row)}  >
                                                        <EditIcon />
                                                    </IconButton>}</TableCell>
                                                </TableRow>
                                            ))}
                                            {emptyRows > 0 && (
                                                <TableRow style={{ height: 53 * emptyRows }}>
                                                    <TableCell colSpan={6} />
                                                </TableRow>
                                            )}
                                        </TableBody>
                                        <TableFooter>
                                            <TableRow>
                                                <TablePagination
                                                    rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                                    colSpan={6}
                                                    count={tableData.length}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    SelectProps={{
                                                        inputProps: {
                                                            'aria-label': 'rows per page',
                                                        },
                                                        native: true,
                                                    }}
                                                    onPageChange={handleChangePage}
                                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                                    ActionsComponent={TablePaginationActions}
                                                />
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>
                            </Card>
                        </Stack>
                    }
                </Container>
            </Page>
        </>
    );
}